<template>
  <apexchart type="line" :options="compoundChart" :series="compoundSeries" :height="height" :width="width"></apexchart>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";

Vue.component("apexchart", VueApexCharts);

export default {
  props: {
    compoundSeries: Array,
    height: Number,
    width: Number,
  },
  data() {
    return {
      compoundChart: {
        chart: {
          offsetX: -15,
          id: "compound",
          group: "smp",
          type: "line",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          tooltip: {
            enabled: false,
          },
          type: "datetime",
          labels: {
            datetimeUTC: false,
            style: {
              fontSize: "12px",
              colors: "primary",
            },
          },
        },

        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
          theme: true,
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          position: "bottom",
          labels: {
            colors: "primary",
          },
        },
        yaxis: 
        [
        {
          max: 35,
          min: 0,
          tickAmount: 5,
          axisTicks: {
            show: true,
          },
          labels: {
            offsetX: -17,
            style: {
              fontSize: "12px",
              colors: "primary",
            },
            formatter: (val) => {
              return val + " mg/m³";
            },
          },
      },
      {
        max: 10,
        min: 0,
        tickAmount: 5,
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: (val) => {
              return val + " mg/m³";
            },
          },
      },
      {
        max: 10,
        min: 0,
        tickAmount: 5,
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: (val) => {
              return val + " ug/m³";
            },
          },
      }
      ],
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
      },
    };
  },
};
</script>